module.exports = __webpack_public_path__ + "img/data-management.1ee5e334.svg";